import Webforms from './common/webforms';
import CartDrawer from './common/cartDrawer';
import Menu from './components/menu';
import Popup from './components/popup';

import {
  getPriceProd,
  initPurchase,
  setScroll,
  setSearch,
  setBlocks,
  verifyClientAccess,
} from './components/utilities';

// ==========================================
// LazyLoad
// ==========================================
window.lazyLoadOptions = {
  elements_selector: '.lazy',
  threshold: -1,
};
window.addEventListener(
  'LazyLoad::Initialized',
  (event) => {
    window.lazyLoadInstance = event.detail.instance;
  },
  false
);

// ==========================================
// Inicialização
// ==========================================
console.log(
  '%cVnda - Tecnologia em Ecommerce',
  'color: #f88d5b; font-size: 15px; font-family: "Verdana", sans-serif; font-weight: bold;'
);

window.addEventListener('DOMContentLoaded', () => {
  Menu.init();
  Popup.init();
  Webforms.init();
  CartDrawer.init();

  setSearch();
  setScroll();
  setBlocks();
  initPurchase();
  getPriceProd();
  verifyClientAccess()
});
